import React, { Component } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export class CaseStudyDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      caseStudy: null,
      loading: true,
    };
  }

  async componentDidMount() {
    try {
      const slug = window.location.pathname.split("/").pop();

      const formData = new FormData();
      formData.append("cs_slug", slug);

      const response = await fetch(
        "https://idealtechnoride.in/api/case-study",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      this.setState({
        caseStudy: data.length > 0 ? data[0] : null,
        loading: false,
      });
    } catch (error) {
      console.log(error);

      this.setState({
        loading: false,
      });
    }
  }

  render() {
    const { caseStudy, loading } = this.state;

    const seoData = caseStudy
      ? {
          seo_meta_title: caseStudy.cs_meta_title,
          seo_meta_description:
            caseStudy.cs_meta_description,
          seo_meta_keywords:
            caseStudy.cs_meta_keywords,
          seo_canonical_url:
            caseStudy.cs_canonical_url,
          seo_og_title:
            caseStudy.cs_og_title,
          seo_og_description:
            caseStudy.cs_og_description,
          seo_robots:
            caseStudy.cs_robots,
        }
      : null;

    if (loading) {
      return (
        <div className="container py-5 text-center">
          <h3>Loading...</h3>
        </div>
      );
    }

    if (!caseStudy) {
      return (
        <div className="container py-5 text-center">
          <h3>Case Study Not Found</h3>
        </div>
      );
    }

    return (
      <>
        <SEO seo={seoData} />

        {/* Hero Start */}
        <div className="container-fluid pb-5 hero-header mb-5">
          <div className="container py-5">
            <div className="row g-3 align-items-center">
              <div className="col-lg-6 text-center text-lg-start">
                <h1 className="display-3 mb-0 animated slideInLeft">
                  {caseStudy.cs_title}
                </h1>
              </div>

              <div className="col-lg-6 animated slideInRight">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center justify-content-lg-end mb-0">
                    <li className="breadcrumb-item">
                      <Link
                        className="text-secondary"
                        to="/"
                      >
                        Home
                      </Link>
                    </li>

                    <li className="breadcrumb-item">
                      <Link
                        className="text-secondary"
                        to="/case-studies"
                      >
                        Case Studies
                      </Link>
                    </li>

                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      {caseStudy.cs_title}
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        {/* Hero End */}

        <div className="container py-5">
          {caseStudy.cs_banner_image && (
            <div className="mb-5">
              <img
                src={caseStudy.cs_banner_image}
                alt={caseStudy.cs_title}
                className="img-fluid rounded w-100"
              />
            </div>
          )}

          <div className="row">
            <div className="col-lg-8">
              <div className="mb-4">
                <span className="badge bg-primary fs-6">
                  {caseStudy.cs_category}
                </span>
              </div>

              <div className="mb-5">
                <h3>Client</h3>
                <p>{caseStudy.cs_client_name}</p>
              </div>

              <div className="mb-5">
                <h3>Project Overview</h3>
                <p>
                  {caseStudy.cs_project_overview}
                </p>
              </div>

              <div className="mb-5">
                <h3>Challenge</h3>
                <p>{caseStudy.cs_challenge}</p>
              </div>

              <div className="mb-5">
                <h3>Solution</h3>
                <p>{caseStudy.cs_solution}</p>
              </div>

              <div className="mb-5">
                <h3>Process</h3>
                <p>{caseStudy.cs_process}</p>
              </div>

              <div className="mb-5">
                <h3>Technologies Used</h3>

                <div className="d-flex flex-wrap gap-2">
                  {caseStudy.cs_technologies &&
                    caseStudy.cs_technologies
                      .split(",")
                      .map((tech, index) => (
                        <span
                          key={index}
                          className="badge bg-secondary p-2"
                        >
                          {tech.trim()}
                        </span>
                      ))}
                </div>
              </div>

              <div className="mb-5">
                <h3>Results</h3>
                <p>{caseStudy.cs_results}</p>
              </div>

              <div className="mb-5">
                <h3>Conclusion</h3>
                <p>{caseStudy.cs_conclusion}</p>
              </div>

              <Link
                to="/case-studies"
                className="btn btn-primary px-4 py-2"
              >
                {caseStudy.cs_back_button_text ||
                  "Back To Case Studies"}
              </Link>
            </div>

            <div className="col-lg-4">
              <div className="bg-light p-4 rounded">
                <h4 className="mb-4">
                  Project Information
                </h4>

                <div className="mb-3">
                  <strong>Project:</strong>
                  <br />
                  {caseStudy.cs_title}
                </div>

                <div className="mb-3">
                  <strong>Client:</strong>
                  <br />
                  {caseStudy.cs_client_name}
                </div>

                <div className="mb-3">
                  <strong>Category:</strong>
                  <br />
                  {caseStudy.cs_category}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CaseStudyDetail;